export default {
    list: {
        title: 'Activity',
        subtitle: 'View recent activity',
        loading: 'Loading activity...',
    },
    sender: {
        title: 'Activity',
        subtitle: 'Updates and notifications for your Sender account',
    },
    shipper: {
        title: 'Activity',
        subtitle: 'Updates and notifications for your Shipper account',
    },
    receiver: {
        title: 'Activity',
        subtitle: 'Updates and notifications for your Receiver account',
    },
    freightForwarder: {
        title: 'Activity',
        subtitle: 'Operational updates for your Freight Forwarder account',
    },
};
